import {
    inject,
    observer,
} from 'mobx-react';
import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
    TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import classes from './facilitiesReports.module.scss';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
    translate,
} from '../../helperFunctions/translation';
import {
    FacilitiesCategoriesStore,
} from '../../mobx-store/stores/facilitiesCategoriesStore';
import {
    CountryStore,
} from '../../mobx-store/stores/countryStore';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import { FacilityStore } from '../../mobx-store/stores/facilitiesStore';
import SearchFilterDropdown from '../../components/SearchFilterComponent/SearchFilterDropdown';
import {IProps as ISearchDropDownProps} from '../../components/SearchFilterComponent/SearchFilterDropdown';
import { Fab, Button } from '@material-ui/core';
import { IRatingFacilitiesReportsOptions } from '../../mobx-store/storeInterfaces/facilitiesInterface';

interface ISearchDropDownFilterProps extends ISearchDropDownProps {
    ref: React.RefObject<SearchFilterDropdown>;
    clearInput: (ref: React.RefObject<SearchFilterDropdown>)=> {};
}

interface IProps extends WithSnackbarProps {
    countryStore: CountryStore;
    facilityStore: FacilityStore;
    facilitiesCategoriesStore: FacilitiesCategoriesStore;
    match: any;
    history: any;
    location: any;
}

interface IState {
    categoryId: number;
    rating: number;
}

@inject('facilityStore')
@inject('countryStore')
@inject('facilitiesCategoriesStore')
@observer
class RatingFacilitiesReport extends Component<IProps, IState> {
    addButton: any;
    categoriesList: any;
    ratingList: any;
    branchId: number = -1;
    areaId: number = -1;
    searchText: string = '';
    tableHeader: any = [];
    tableData: any = [];
    tableCellTypes: TableCellTypes[] = [];
    title: string = translate('facilitiesListPageTitle', {});
    
    searchFiltersProps: ISearchDropDownFilterProps[] = [];

    constructor(props: IProps) {
        super(props);
    }

    handleClearFilterByCategory = async (ref: React.RefObject<SearchFilterDropdown>) => {
        if (ref.current) {
            ref!.current.clear();
        }
        await this.handleCategoryChange(0);
    }
    handleClearFilterByRating = async (ref: React.RefObject<SearchFilterDropdown>) => {
        if (ref.current) {
            ref!.current.clear();
        }
        await this.handleRatingChange(0);
    }

    getSearchFilterProps = () => {
        return [
            {
                label: "Filter by Category",
                searchFilterDropdown: this.categoriesList,
                ref: React.createRef<SearchFilterDropdown>(),
                clearInput: this.handleClearFilterByCategory,
            },
            {
                label: "Filter by Rating",
                searchFilterDropdown: this.ratingList,
                ref: React.createRef<SearchFilterDropdown>(),
                clearInput: this.handleClearFilterByRating,
            },
        ]
    }

    handleSearchChanged = async (title: string) => {
        try {
            this.searchText = title;
            const options: IRatingFacilitiesReportsOptions = {
                availableCountries: this.props.countryStore.managedCountries,
                query: title,
                areaId: this.areaId,
                branchId: this.branchId,
            }
            await this.props.facilityStore.getRatingFacilitiesReport(options);
        } catch (error) {
            throw error;
        }
    };

    getCategoriesList = () => ({
        value: this.state.categoryId,
        onChange: this.handleCategoryChange.bind(this),
        filters: this.props.facilitiesCategoriesStore.categoriesList.map( (category) => {
            return {
                value: category.facilityCategoryId,
                name: category.title,
            };
        }),
    });

    getRatingList = () => ({
        value: this.state.rating,
        onChange: this.handleRatingChange.bind(this),
        filters: [
            {
                value: 1,
                name: "1",
            },
            {
                value: 2,
                name: "2",
            },
            {
                value: 3,
                name: "3",
            },
            {
                value: 4,
                name: "4",
            },
            {
                value: 5,
                name: "5",
            },
        ],
    });

    asyncSetState = async<K extends keyof IState>(state: Pick<IState, K>) => new Promise((res) => {
        this.setState({
            ...state,
        }, () => res());
    });

    handleCategoryChange = async (categoryId: number) => {
        try {
            this.setState({
                categoryId,
            });
            const options: IRatingFacilitiesReportsOptions = {
                categoryId,
                availableCountries: this.props.countryStore.managedCountries,
                areaId: this.areaId,
                query: this.searchText,
                branchId: this.branchId,
                rating: this.state.rating ? this.state.rating : undefined,
            };
            await this.props.facilityStore.getRatingFacilitiesReport(options);
        } catch (error) {
            throw error;
        }
    };

    handleRatingChange = async (rating: number) => {
        try {
            this.setState({
                rating,
            });
            const options: IRatingFacilitiesReportsOptions = {
                rating,
                availableCountries: this.props.countryStore.managedCountries,
                categoryId: this.state.categoryId ? this.state.categoryId : undefined,
                areaId: this.areaId,
                query: this.searchText,
                branchId: this.branchId,
            };
            await this.props.facilityStore.getRatingFacilitiesReport(options);
        } catch (error) {
            throw error;
        }
    };

    handleClearFilter = async () => {
        this.setState({
            categoryId: 0,
            rating: 0
        }, async () => {
            this.searchFiltersProps.map( (searchFilterProp) => {
                if (searchFilterProp.ref!.current) {
                    searchFilterProp.ref!.current.clear();
                }
            });
    
            const options: IRatingFacilitiesReportsOptions = {
                availableCountries: this.props.countryStore.managedCountries,
            };
    
            await this.props.facilityStore.getRatingFacilitiesReport(options);    
        })
    }

    handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
        this.props.facilityStore.updateFacilityStatus(index, value)
            .then(() => {
                SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
                }), 8000, 'success');
            })
            .catch((error: any) => {
                SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
                }), 8000, 'error');
            });
    };

    getFacilityTableHeader = () => {
        const headers = [
            {
                title: translate('ratingFacilityReportFacilityName', {}),
            },
            {
                title: translate('ratingFacilityReportCategoryName', {}),
            },
            {
                title: translate('ratingFacilityReportBranchName', {}),
            },
            {
                title: translate('ratingFacilityReportAreaName', {}),
            },
            {
                title: translate('ratingFacilityReportRating', {}),
            },
            {
                title: 'View',
            },
            {
                title: 'Statistics',
            },
            {
                title: 'Export',
            },
        ];

        return headers;
    }

    handleTableButtonCellClicked = (index: number, key: string) => {
        this.props.history.push(`/facilities/rating/reports/${this.props.facilityStore.facilitiesList[index].facilityId}`);
    };

    handleTableButtonStatisticsClicked = (index: number, key: string) => {
        this.props.history.push(`/facilities/${this.props.facilityStore.facilitiesList[index].facilityId}/statistics`);
    };

    handleTableButtonExportClicked = async (index: number) => {
        const options = {
            availableCountries: this.props.countryStore.managedCountries,
        };
        await this.props.facilityStore.exportFacilityResponsesList(
            this.props.facilityStore.facilitiesList[index].facilityId, options,
        );
    };

    getTableData = () => this.props.facilityStore.facilitiesList
    .map((facility) => ({
        ...facility,
        view: 'View',
        statistics: 'Statistics',
        export: 'Export Ratings',
    }));

    getRatingFacilityTableCellTypes = (): TableCellTypes[] => {
        const cellTypes: TableCellTypes[] = [
            {
                cellType: 'Text',
                key: 'name',
            },
            {
                cellType: 'Text',
                key: 'categoryName',
            },
            {
                cellType: 'Text',
                key: 'branchName',
            },
            {
                cellType: 'Text',
                key: 'areaName',
            },
            {
                cellType: 'Text',
                key: 'facilityRatings',
            },
            {
                cellType: 'Button',
                key: 'view',
                onClick: this.handleTableButtonCellClicked,
            },
            {
                cellType: 'Button',
                key: 'statistics',
                onClick: this.handleTableButtonStatisticsClicked,
            },
            {
                cellType: 'Button',
                key: 'export',
                onClick: this.handleTableButtonExportClicked,
            },
        ];

        return cellTypes;
    }

    initTable = () => {
        this.tableHeader = this.getFacilityTableHeader();
        this.tableCellTypes = this.getRatingFacilityTableCellTypes();
        this.tableData = this.getTableData();
    };

    render() {
        this.initTable();
        this.categoriesList = this.getCategoriesList();
        this.ratingList = this.getRatingList();
        this.searchFiltersProps = this.getSearchFilterProps();

        return (
            <div className={classes.container}>
                <GeneralSearchComponent
                    onSearchClick={this.handleSearchChanged}
                    searchBy="title"
                />
    
                <div className={classes.dropdownsContainer}>
                    {
                        this.searchFiltersProps.map( (searchFilterProp: ISearchDropDownFilterProps) => {
                            
                            return <div className={classes.filterInput}>
                                <SearchFilterDropdown
                                label={searchFilterProp.label}
                                searchFilterDropdown={searchFilterProp.searchFilterDropdown}
                                ref={searchFilterProp.ref}
                                />
                                <Button 
                                color="secondary"
                                className={classes.clearbutton}
                                onClick={() => searchFilterProp.clearInput(searchFilterProp.ref) } 
                                >
                                X
                                </Button>
                                </div>
                        })
                    }
                </div>

                <Fab
                    onClick={() => this.handleClearFilter()}
                    color="primary"
                    variant="extended"
                    className={classes.clearFilterButton}
                >
                    {translate('newsListClearFiltersButton', {
                    })}
                </Fab>

                <GeneralTableComponent
                    emptyMessage={translate('facilitiesListNoFacilitiesMessage', {
                    })}
                    title={this.title}
                    tableHeader={this.tableHeader}
                    tableData={this.tableData}
                    tableCellTypes={this.tableCellTypes}
                    addButton={this.addButton}
                    loading={this.props.facilityStore.loading}
                    loadingStatus={[
                        this.props.facilityStore.getFacilitiesRequestStatus,
                        this.props.countryStore.getManagedCountriesRequestStatus
                    ]}
                />
            </div>
        );
    }

    async componentDidMount() {
        const {
            countryStore,
            facilityStore,
            facilitiesCategoriesStore,
        } = this.props;
        
        await countryStore.getUserManagedCountries();
        this.branchId = this.props.match.params.branchId;
        this.areaId = this.props.match.params.areaId;
        
        const options: IRatingFacilitiesReportsOptions = {
            availableCountries: this.props.countryStore.managedCountries,
            branchId: this.branchId,
            areaId: this.areaId,
        };
        
        await facilityStore.getRatingFacilitiesReport(options);
        facilitiesCategoriesStore.getFacilityCategories(options.availableCountries, "RATING");
    }

    componentWillMount() {
        this.setState({
            categoryId: 0,
            rating: 0,
        });
    }
}

export default RatingFacilitiesReport;
